import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    accountSettings: []
  },
  mutations: {
    SET_ACCOUNT_SETTINGS (store, items) {
      store.accounts.selectIds = items
    }
  },
  getters: {
    getAccountSettings: (store, getters) => {
      return store.accounts.accountSettings
    }
  },
  actions: {
    /*
    selectAccountSettings
    */
    selectAccountSettings ({commit, dispatch, getters, state}, filters) {
      return dispatch('getAccountSettings', filters).then((response) => {
        commit('SET_ACCOUNT_SETTINGS', response)
        return response
      })
    },
    /*
    getAccountSettings
    */
    getAccountSettings ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${id}/account-settings`)
      .then((response) => {
        return response.data
      })
    },
    /*
    updateAccountSettings
    */
    updateAccountSettings ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${data._id}/account-settings`, data)
      .then((response) => {
        dispatch('setWarn', { status: 'success' })
        return response.data
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/accountSettings.js